<template>
  <div class="content ">
    <BlockUI
      v-if="blockScreen"
      :url="blockScreenData.url"
      :message="blockScreenData.msg"
    ></BlockUI>

    <v-card>
      <v-card-title class="title font-weight-medium">
        Feedback de reservas
      </v-card-title>

      <v-card-subtitle>
        <v-flex class="my-2">
          <v-row justify="space-between">
            <v-flex xs12 md3 sm6>
              <v-col align="start">
                <v-autocomplete
                  v-model="client"
                  :items="clients"
                  item-text="name"
                  item-value="id"
                  label="Cliente"
                  :clearable="true"
                  :search-input.sync="getVehiclesAndUsersByClient"
                  prepend-icon="mdi-office-building"
                  no-data-text="Nenhum cliente encontrado"
                />
              </v-col>
            </v-flex>

            <v-flex xs12 md3 sm6>
              <v-col align="start">
                <v-autocomplete
                  v-model="vehicle"
                  :items="vehicles"
                  item-text="plate"
                  item-value="id"
                  label="Veículo"
                  :clearable="true"
                  :disabled="client == null ? true : false"
                  :messages="client == null ? 'Selecione um cliente' : ''"
                  prepend-icon="mdi-car"
                  no-data-text="Nenhum veículo encontrado"
                />
              </v-col>
            </v-flex>

            <v-flex xs12 md3 sm6>
              <v-col align="start">
                <v-autocomplete
                  v-model="user"
                  :items="users"
                  item-text="name"
                  item-value="id"
                  label="Usuário (opcional)"
                  :clearable="true"
                  :disabled="client == null ? true : false"
                  :messages="client == null ? 'Selecione um cliente' : ''"
                  prepend-icon="mdi-account"
                  no-data-text="Nenhum usuário encontrado"
                />
              </v-col>
            </v-flex>

            <v-flex xs12 md2 sm6>
              <v-col align="center">
                <v-btn
                  block
                  class="mt-4 white--text"
                  color="primary"
                  @click="getFeedbacks()"
                >
                  Pesquisar
                </v-btn>
              </v-col>
            </v-flex>
          </v-row>

          <v-row justify="space-between">
            <v-flex xs12 md3 sm6>
              <v-col align="start">
                <v-text-field
                  v-model="search"
                  single-line
                  hide-details
                  prepend-icon="mdi-magnify"
                  label="Pesquisar nos resultados"
                  :disabled="this.feedbacks.length > 0 ? false : true"
                ></v-text-field>
              </v-col>
            </v-flex>

            <v-flex xs12 md2 sm6>
              <v-col align="center">
                <download-excel
                  :data="feedbacks"
                  :fields="jsonFields"
                  name="feedbacks.xls"
                >
                  <v-btn
                    :disabled="feedbacks.length > 0 ? false : true"
                    block
                    class="mt-4 white--text"
                    color="success"
                  >
                    Exportar
                    <v-icon right dark>
                      mdi-file-excel
                    </v-icon>
                  </v-btn>
                </download-excel>
              </v-col>
            </v-flex>
          </v-row>
        </v-flex>
      </v-card-subtitle>

      <v-card-text>
        <v-flex class="mx-3 my-2" xs12 md12>
          <v-row justify="start">
            <v-col align="start">
              <v-data-table
                :headers="headers"
                :search="search"
                :items="feedbacks"
                class="elevation-1 mt-2"
                no-data-text="Nenhum feedback registrado"
                footer-props.items-per-page-text="Linhas por página"
              >
                <template v-slot:item="{ item }">
                  <tr>
                    <td class>{{ item.vehicle_request_id }}</td>
                    <td class>{{ item.vehicle_request.vehicle.plate }}</td>
                    <td class>{{ item.vehicle_request.user.name }}</td>
                    <td class>{{ item.created_at | formatDate }}</td>
                    <td class>{{ item.form_date.rating }}</td>
                    <td class>
                      {{ item.form_date.estadoCarroDefeito ? 'Sim' : 'Não' }}
                    </td>
                    <td class>{{ item.form_date.obsDefeitoCarro }}</td>
                    <td class>{{ item.form_date.estadoGeralCarro }}</td>
                    <td class>{{ item.form_date.obsOutras }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-flex>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import moment from 'moment';
import { blockScreenUi } from '../../helpers/BlockScreenUi';

import UserController from '../../controllers/UserController';
import ClientController from '../../controllers/ClientController';
import VehicleController from '../../controllers/VehicleController';
import FeedbackController from '../../controllers/FeedbackController.js';

export default {
  data() {
    return {
      blockScreen: false,
      blockScreenData: blockScreenUi.blockScreenData,
      userController: new UserController(this.$resource),
      clientController: new ClientController(this.$resource),
      vehicleController: new VehicleController(this.$resource),
      feedbackController: new FeedbackController(this.$resource),

      feedbacks: [],

      search: '',

      getVehiclesAndUsersByClient: null,

      user: null,
      client: null,
      vehicle: null,

      users: [],
      clients: [],
      vehicles: [],

      jsonFields: {
        'ID da Reserva': 'vehicle_request_id',
        Placa: 'vehicle_request.vehicle.plate',
        Usuário: 'vehicle_request.user.name',
        Data: 'created_at',
        Avaliação: 'form_date.rating',
        Defeito: 'form_date.estadoCarroDefeito',
        'Obs. Defeito': 'form_date.obsDefeitoCarro',
        'Estado geral do carro': 'form_date.estadoGeralCarro',
        'Obs. Gerais': 'form_date.obsOutras',
      },

      headers: [
        { text: 'ID da Reserva', value: 'vehicle_request_id' },
        { text: 'Placa', value: 'vehicle_request.vehicle.plate' },
        { text: 'Usuário', value: 'vehicle_request.user.name' },
        { text: 'Data', value: 'created_at' },
        { text: 'Avaliação', value: 'form_date.rating' },
        { text: 'Defeito', value: 'form_date.estadoCarroDefeito' },
        { text: 'Obs. Defeito', value: 'form_date.obsDefeitoCarro' },
        { text: 'Estado geral do carro', value: 'form_date.estadoGeralCarro' },
        { text: 'Obs. Gerais', value: 'form_date.obsOutras' },
      ],
    };
  },

  created() {
    this.getAllClients();
  },

  methods: {
    async getAllClients() {
      try {
        this.clients = [];
        this.clients = await this.clientController.getAllClients();
      } catch (error) {
        this.$awn.alert('Falha ao recuperar clientes.');
      }
    },

    async getVehiclesByClient(id) {
      try {
        this.vehicles = [];
        this.vehicles = await this.vehicleController.getByParamClientId(id);
      } catch (error) {
        console.error(error);
        this.$awn.alert('Erro ao recuperar veículos desse cliente.');
      }
    },

    async getUsersActiveByClientId(id) {
      try {
        this.users = [];
        this.users = await this.userController.getUsersActiveByClientId(id);
      } catch (error) {
        console.error(error);
        this.$awn.alert('Erro ao recuperar usuários desse cliente.');
      }
    },

    async getFeedbacks() {
      try {
        this.blockScreen = true;
        this.feedbacks = await this.feedbackController.getFeedbacks(
          this.client,
          this.vehicle,
          this.user
        );
      } catch (error) {
        this.$awn.success(error);
      } finally {
        this.blockScreen = false;
      }
    },
  },

  watch: {
    async getVehiclesAndUsersByClient() {
      try {
        this.blockScreen = true;

        this.user = null;
        this.vehicle = null;

        if (this.client) {
          await this.getVehiclesByClient(this.client);
          await this.getUsersActiveByClientId(this.client);
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.blockScreen = false;
      }
    },
  },

  filters: {
    formatDate(dateString) {
      if (dateString) {
        return moment(dateString).format('DD[/]MM[/]YYYY HH:mm');
      }
    },
  },
};
</script>
